import { FormDialog } from "@dzambalaorg/mui-dialog-form";
import { EntityInput } from "@dzambalaorg/mui-inputs-entity";
import { SelectInput, TextInput } from "@dzambalaorg/mui-inputs-core";
import { TemplateAssetInput } from "@dzambalaorg/mui-inputs-asset";
import { ContractFeatures, IRent, RentRuleStatus, TokenType } from "@framework/types";
import { IMutationProps, useDialogForm } from "@dzambalaorg/react-hooks";
import { cleanUpAsset } from "@framework/exchange";

import { validationSchema } from "./validation";

export interface IRentDialogFormProps extends IMutationProps, Pick<ReturnType<typeof useDialogForm>, "mode"> {
  open: boolean;
  selectedItem: IRent | null;
}

export const RentDialogForm = (props: IRentDialogFormProps) => {
  const { selectedItem, open, mode, ...rest } = props;

  if (!open || !selectedItem) {
    return null;
  }

  const { id, title, rentStatus, price, contractId } = selectedItem;
  const fixedValues = {
    id,
    price,
    contractId,
    title,
    rentStatus,
  };

  return (
    <FormDialog
      open={open}
      initialValues={fixedValues}
      validationSchema={validationSchema}
      message={`dialogs.${mode}`}
      testId="GradeEditForm"
      filter={({ price, contractId, title, rentStatus }) => ({
        price: cleanUpAsset(price) as any,
        contractId,
        title,
        rentStatus,
      })}
      {...rest}
    >
      <TextInput name="title" required />
      {mode === "edit" && (
        <SelectInput name="rentStatus" options={RentRuleStatus} disabledOptions={[RentRuleStatus.NEW]} />
      )}
      <EntityInput
        required
        name="contractId"
        controller="contracts"
        fetchData={{ contractFeatures: [ContractFeatures.RENTABLE] }}
      />
      <TemplateAssetInput
        required
        autoSelect
        multiple
        prefix="price"
        tokenType={{ disabledOptions: [TokenType.ERC721, TokenType.ERC998] }}
      />
    </FormDialog>
  );
};
